import React, { Component, Fragment, useRef } from 'react';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import CustomSelect from '../../common/formElements/CustomSelect';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import cookie from 'react-cookies';
import { connect } from 'react-redux';
import axios from 'axios';
import {
  REST_API,
  ZAPIER,
  CHAT_GPT,
  SUPABASE,
  DIRECTUS,
  APP_WRITE,
  XANO,
  pluginCode,
  BelongsCreatedByRefField,
  SNIPPET_TYPES,
} from 'drapcode-constant';
import { dynamicSort, snakeCaseToTitleCase } from '../../common/utils/api_utils';
import * as actions from '../../features/events/redux/actions';
import * as templateActions from '../../features/template/redux/actions';
import * as externalApiActions from '../../features/external-api/redux/actions';
import * as appSettingActions from '../../features/app-setting/redux/actions';
import * as customComponentsActions from '../../features/custom-component/redux/actions';
import {
  getPageComponentElement,
  pageElementOptionsForResetPassword,
  getPageComponentElementWithCollectionFieldValue,
} from './PageComponentUtils';
import { pageShowHideComponentOptions } from './ShowHideComponentUtils';
import { builderSurfaceJsonContentHeader } from '../../common/utils/restApiHeaderUtils';
import CustomLoader from '../common/CustomLoader';
import {
  CUSTOM_MODAL_SEPARATOR,
  getDirectionLinkText,
  getFieldDescriptionInfoByName,
  getFieldDescriptionText,
  getFieldDescriptionTextByName,
  getSnippetModalOptions,
  validateSubmitBtn,
} from './ActionFormUtils';
import history from '../../common/history';
import { iconForField } from '../../common/custom/icon-library';
import { getBuilderURL } from '../../common/utils/builder-url-util';
import CustomInputWithIconNoFormGroup from '../../common/ui/CustomInputWithIconNoFormGroup';
import {
  getPageComponentOptions,
  getPageComponents,
  pageRefreshElementOptions,
} from '../../common/utils/page_utils';
import {
  collectionRequestOptions,
  COLLECTION_API,
  COLLECTION_FIELD_API,
  COLLECTION_REQUEST_API,
  DS_EXTERNAL_API,
  DS_ZAPS,
  DS_CHAT_GPT,
  DS_API_COLLECTION_FIELDS,
  EMAIL_TEMPLATE_API,
  HIDE_COMPONENT_PAGE_API,
  HIDE_PAGE_COMPONENTS,
  MODAL_API,
  SUB_PAGE_API,
  PDF_TEMPLATE_API,
  PAGE_SUB_PAGE_COMPONENTS_API,
  CUSTOM_COMPONENT_API,
  PAGE_CUSTOM_COMPONENT_COMPONENTS_API,
  PAGE_API,
  PAGE_COLLECTION_FORM_COMPONENT,
  PAGE_COMPONENT,
  PAGE_FORM_COMPONENT,
  PAGE_FORM_COMPONENTS,
  refreshShowHideOpts,
  REFRESH_PAGE_API,
  REFRESH_PAGE_COMPONENT,
  RESET_PASSWORD_PAGE_COMPONENT,
  sendDataToApiOptions,
  SHOW_COMPONENT_PAGE_API,
  SHOW_PAGE_COMPONENTS,
  USER_ROLE_API,
  waitTimeOptions,
  WAIT_TIME_OPTIONS_IN_SECOND,
  COLLECTION_CONSTRUCTOR_API,
  DEFAULT_USER_COLLECTION,
  LOCALIZATION_API,
  MULTI_TENANT_API,
  TENANT_CONSTRUCTOR_API,
  SOURCE_API,
  SOURCE_PAGE_API,
  sourceOptions,
  dropdownSourceOpts,
  TOOLTIP_API,
  TOOLTIP_POSITION,
  toolTipPositionOptions,
  TOOLTIPS_THEME,
  toolTipsThemeOptions,
  toolTipsAnimationOptions,
  TOOLTIPS_ANIMATION,
  toolTipsFollowCursorOptions,
  TOOLTIPS_FOLLOW_CURSOR,
  SMS_TEMPLATE_API,
  DS_SUPABASE,
  DS_DIRECTUS,
  DS_APPWRITE,
  DS_XANO,
  AGREEMENT_TEMPLATE_API,
  AGREEMENT_TEMPLATE_PDF_API,
  TYPESENSE_SEARCH_COLLECTION_API,
  EMAIL_SERVICE_PLUGIN_API,
  COLLECTION_META_DATA_MAPPING_API,
  getItemIdFromOptions,
  GET_ITEM_ID_FROM_API,
  FLOATING_MODAL_API,
  SMS_SERVICE_PLUGIN_API,
  getItemIdForLogoutOptions,
  LOGOUT_ITEM_API,
  browserStorageAndConsoleArgs,
  PAGE_SIGN_PAD_COMPONENTS_API,
} from '../../common/utils/event_constants';
import { getLanguageNameFromCode } from '../../common/utils/languages';
import TooltipInfo from '../../common/docs/TooltipInfo';
import * as toolTipActions from '../../features/template/redux/actions';
import BrowserStorageLocationField from './action/BrowserStorageLocationField';
import { getCollectionItemList, getUserRoleFromApi } from '../../common/utils/item-util';
import { createSelectOptionsForReferenceField } from '../collections/collection/derived-query/query-util';
import BrowserStorageOptions from './action/BrowserStorageOptions';
import ConsoleLogOptions from './ConsoleLogOptions';

export const createActionSettingsSchema = (actionData, eventAction) => {
  let schema = {};
  actionData.args.forEach((args) => {
    const dbParameters = eventAction.parameters.find((param) => param.name === args.name);
    schema[args.name] = dbParameters ? dbParameters.value : '';
  });
  return schema;
};

class ActionForm extends Component {
  static propTypes = {
    events: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    projectId: PropTypes.string.isRequired,
  };

  state = {
    pageContent: {},
    pageId: '',
    roles: [],
    refreshPageContent: {},
    refreshPageId: '',
    showHideComponentPageContent: {},
    showHideComponentPageId: '',
    tenants: [],
    showBSLOption: false,
    showCLOption: false,
  };

  componentDidMount() {
    const {
      events,
      projectId,
      version,
      actionData,
      eventAction,
      templateActions,
      externalApiActions,
      appSettingActions,
      customComponentsActions,
      toolTipActions,
    } = this.props;
    const { plugins, collections } = events || '';
    const multiTenantPlugin = plugins && plugins.find((e) => e.code === 'MULTI_TENANT_SAAS');
    templateActions.fetchAllMailTemplate({ projectId, version });
    templateActions.fetchAllSmsTemplate({ projectId, version });
    templateActions.fetchAllAgreementTemplate({ projectId, version });
    externalApiActions.loadExternalApis({ projectId, version });
    appSettingActions.loadLocalizationData({ projectId, version });
    customComponentsActions.loadCustomComponentConfigs({ projectId, version });
    toolTipActions.fetchAllTooltipTemplate({ projectId, version });
    getUserRoleFromApi(projectId, version).then((res) => {
      this.setState({ ...this.state, roles: res && Array.isArray(res) ? res : [] });
    });
    const values = createActionSettingsSchema(actionData, eventAction);
    actionData.args.forEach((arg) => this.onChangeHandle(arg, values));
    if (multiTenantPlugin) {
      const {
        setting: { multiTenantCollection },
      } = multiTenantPlugin || '';
      const selectedMultiTenantCollection = collections.find(
        (collection) => collection.uuid === multiTenantCollection && collection.isTenantCollection,
      );

      selectedMultiTenantCollection &&
        getCollectionItemList(
          projectId,
          version,
          selectedMultiTenantCollection.collectionName,
        ).then((res) => {
          this.setState({
            ...this.state,
            tenants: res && Array.isArray(res) ? res : [],
          });
        });
    }
  }

  handleChange = (name, value) => {
    this.setState({ [name]: value });
  };

  closeAllOpenPopup = (args) => {
    let token = cookie.load('token');
    const redirectUrl = getBuilderURL();
    const { projectId, actions, events, version } = this.props;
    actions.closeActionFormModal();
    switch (args.optionsType) {
      case PAGE_API:
      case REFRESH_PAGE_API:
      case SHOW_COMPONENT_PAGE_API:
      case HIDE_COMPONENT_PAGE_API:
        window.location.href = `${redirectUrl}editor/${version}/v/${projectId}/loader?open-modal=create-page&token=${
          token ? token : ''
        }`;
        break;
      case USER_ROLE_API:
        const { collections } = events;
        const roleCollection = collections.find(
          (collection) => collection.collectionName === 'role',
        );
        if (roleCollection) {
          history.push(
            `/2.0/collections/${version}/v/${projectId}/items/${roleCollection.uuid}/name/role`,
          );
        }
        break;
      case AGREEMENT_TEMPLATE_API:
      case EMAIL_TEMPLATE_API:
        history.push(`/2.0/template/${version}/v/${projectId}/`);
        break;
      case PAGE_COMPONENT:
      case REFRESH_PAGE_COMPONENT:
      case SHOW_PAGE_COMPONENTS:
      case HIDE_PAGE_COMPONENTS:
      case MODAL_API:
      case FLOATING_MODAL_API:
      case SUB_PAGE_API:
      case PDF_TEMPLATE_API:
      case PAGE_SUB_PAGE_COMPONENTS_API:
      case CUSTOM_COMPONENT_API:
      case PAGE_CUSTOM_COMPONENT_COMPONENTS_API:
      case PAGE_SIGN_PAD_COMPONENTS_API:
        break;
      case DS_EXTERNAL_API:
        history.push(`/2.0/externalapi/${version}/v/${projectId}/create`);
        break;
      case COLLECTION_API:
        history.push(`/2.0/collections/${version}/v/${projectId}/create`);
        break;
      case COLLECTION_REQUEST_API:
        break;
    }
  };

  getSourceOptions = (eventAction) => {
    let options = sourceOptions;
    if (eventAction.name === 'displaySubPage')
      options = options.filter((opt) => opt.value !== 'SUB_PAGE');
    return options;
  };

  getSelectOption = (args, values) => {
    const { events, eventAction, externalApiType } = this.props;
    const { localization } = this.props.appSetting;
    const { customComponents } = this.props.customComponent;
    let pageContent = this.state.showHideComponentPageContent;
    const { plugins, collections } = events || '';
    const installedPluginCodes = plugins.map((p) => p.code);
    let options = [];
    switch (args.optionsType) {
      case PAGE_API:
        options = events.pages.map((item, key) => ({
          value: '/' + item.slug,
          label: item.name,
        }));
        break;
      case LOCALIZATION_API:
        options =
          localization &&
          localization.map((item, key) => ({
            value: item.language,
            label: getLanguageNameFromCode(item.language),
          }));
        break;
      case USER_ROLE_API:
        options = this.state.roles.map((role, key) => ({ value: role.name, label: role.name }));
        break;
      case EMAIL_TEMPLATE_API:
        options = this.props.template.mailTemplates
          .filter((item) => !item.parentTemplateId)
          .sort(dynamicSort('name'))
          .map((item, key) => ({ value: item.uuid, label: item.name }));
        break;
      case SMS_TEMPLATE_API:
        options = this.props.template.smsTemplates
          .filter((item) => !item.parentTemplateId)
          .sort(dynamicSort('name'))
          .map((item, key) => ({ value: item.uuid, label: item.name }));
        break;
      case PAGE_COMPONENT:
        options = this.getComponentsElement();
        break;
      case PAGE_COLLECTION_FORM_COMPONENT: {
        const collectionName = values ? values['collection'] : '';
        const pageComponentId = values ? values['pageComponent'] : '';
        const selectedCollection = collections.find((e) => e.collectionName === collectionName);
        const selectedCollFields = selectedCollection ? selectedCollection.fields : [];
        options = getPageComponentElementWithCollectionFieldValue(
          this.state,
          pageComponentId,
          selectedCollFields,
        );
        break;
      }
      case REFRESH_PAGE_COMPONENT:
        options = this.getRefreshComponentsElement(values);
        break;
      case RESET_PASSWORD_PAGE_COMPONENT:
      case PAGE_FORM_COMPONENT:
        options = pageElementOptionsForResetPassword(this.state);
        break;
      case SHOW_PAGE_COMPONENTS:
      case HIDE_PAGE_COMPONENTS:
        options = this.getShowHidePageComponents(values);
        break;
      case PAGE_FORM_COMPONENTS:
        options = this.getPageFormComponents(values);
        break;
      case MODAL_API:
        options = this.getModalListFromSnippets();
        break;
      case FLOATING_MODAL_API:
        options = this.getModalListFromSnippets(SNIPPET_TYPES.FLOATING_MODAL);
        break;
      case SUB_PAGE_API:
        options = this.getSubPageListFromSnippets();
        break;
      case PDF_TEMPLATE_API:
        options = this.getPdfTemplateListFromSnippets();
        break;
      case CUSTOM_COMPONENT_API:
        options = customComponents
          ? customComponents.map((comp) => ({
              value: comp.uuid,
              label: comp.name,
            }))
          : [];
        break;
      case PAGE_SUB_PAGE_COMPONENTS_API:
        options = getPageComponents(pageContent, ['sub-page']);
        break;
      case PAGE_CUSTOM_COMPONENT_COMPONENTS_API:
        options = getPageComponents(pageContent, ['custom-component']);
        break;
      case PAGE_SIGN_PAD_COMPONENTS_API:
        options = getPageComponents(pageContent, ['signature-pad']);
        break;
      case DS_EXTERNAL_API:
        // options = this.fetchExternalApiList(REST_API);
        options = this.fetchExternalApiList(externalApiType || '');
        break;
      case COLLECTION_API:
        options = this.fetchCollectionList();
        break;
      case COLLECTION_CONSTRUCTOR_API:
        options = this.constructorOptions(DEFAULT_USER_COLLECTION);
        break;
      case TENANT_CONSTRUCTOR_API:
        const multiTenantPlugin = plugins && plugins.find((e) => e.code === 'MULTI_TENANT_SAAS');
        const {
          setting: { multiTenantCollection },
        } = multiTenantPlugin || '';
        const selectedMultiTenantCollection = collections.find(
          (collection) =>
            collection.uuid === multiTenantCollection && collection.isTenantCollection,
        );
        const TenantCollectionName = selectedMultiTenantCollection
          ? selectedMultiTenantCollection.collectionName
          : '';
        options = this.constructorOptions(TenantCollectionName);
        break;
      case COLLECTION_REQUEST_API:
        options = collectionRequestOptions;
        break;
      case WAIT_TIME_OPTIONS_IN_SECOND:
        options = waitTimeOptions;
        break;
      case COLLECTION_FIELD_API: {
        const { name: eventActionName } = eventAction;
        const collectionName = values
          ? ['dependentDropDownPopulateOnChange'].includes(eventActionName)
            ? values['changeValuesCollection']
            : [
                'generateEmailOTP',
                'generateSmsOTP',
                'generateUserConsentEmailOTP',
                'generateUserConsentSmsOTP',
                'createConsentRequest',
              ].includes(eventActionName)
            ? DEFAULT_USER_COLLECTION
            : values['collection']
          : '';
        const selectedCollection = collections.find((e) => e.collectionName === collectionName);
        const selectedCollectionFields = selectedCollection ? selectedCollection.fields : [];
        let referenceFields = [];
        if (
          selectedCollectionFields &&
          selectedCollectionFields.length &&
          collections &&
          collections.length
        ) {
          referenceFields = createSelectOptionsForReferenceField(
            selectedCollectionFields,
            collections,
          );
        }
        if (['saveCollectionAssets', 'updateCollectionAssets'].includes(eventActionName)) {
          options = selectedCollectionFields
            .filter((e) => e.type === 'file' || e.type === 'belongsTo')
            .map((e) => ({
              value: e.fieldName,
              label: e.fieldTitle.en,
            }));
        } else if (
          ['generatePdfFromSection', 'generatePdfFromSnippet'].includes(eventActionName) ||
          args.name === 'saveQRField'
        ) {
          options = selectedCollectionFields
            .filter((e) => e.type === 'file')
            .map((e) => ({
              value: e.fieldName,
              label: e.fieldTitle.en,
            }));
        } else if (['generateUserConsentEmailOTP'].includes(eventActionName)) {
          options = selectedCollectionFields
            .filter((e) => e.type === 'email' || e.fieldName === 'userName')
            .map((e) => ({
              value: e.fieldName,
              label: e.fieldTitle.en,
            }));
        } else if (
          ['generateUserConsentSmsOTP', 'createConsentRequest'].includes(eventActionName)
        ) {
          options = selectedCollectionFields
            .filter((e) => e.type === 'tel')
            .map((e) => ({
              value: e.fieldName,
              label: e.fieldTitle.en,
            }));
        } else if (eventActionName === 'addDataKnowledgeBase') {
          options = selectedCollectionFields
            .filter((e) => e.type === 'file')
            .map((e) => ({
              value: e.fieldName,
              label: e.fieldTitle.en,
            }));
        } else if (eventActionName === 'queryFromKnowledgeBase') {
          options = selectedCollectionFields
            .filter((e) => e.type === 'text' || e.type === 'large_text')
            .map((e) => ({
              value: e.fieldName,
              label: e.fieldTitle.en,
            }));
          if (['fieldForFile'].includes(args.name)) {
            const collectionName = values['collectionForFileField'];
            const selectedCollection = collections.find((e) => e.collectionName === collectionName);
            const selectedCollectionFields = selectedCollection ? selectedCollection.fields : [];
            options = selectedCollectionFields
              .filter((e) => e.type === 'file')
              .map((e) => ({
                value: e.fieldName,
                label: e.fieldTitle.en,
              }));
          }
        } else if (eventActionName === 'answerFromChatbot') {
          if (['fieldForQuery', 'fieldForContext'].includes(args.name)) {
            const collectionName = values['collectionForQuery'];
            const selectedCollection = collections.find((e) => e.collectionName === collectionName);
            const selectedCollectionFields = selectedCollection ? selectedCollection.fields : [];
            options = selectedCollectionFields
              .filter((e) => e.type === 'text' || e.type === 'large_text')
              .map((e) => ({
                value: e.fieldName,
                label: e.fieldTitle.en,
              }));
          } else if (['fieldForQueryContext', 'fieldForAnswer'].includes(args.name)) {
            const collectionName = values['collectionForAiChatbot'];
            const selectedCollection = collections.find((e) => e.collectionName === collectionName);
            const selectedCollectionFields = selectedCollection ? selectedCollection.fields : [];
            options = selectedCollectionFields
              .filter((e) => e.type === 'text' || e.type === 'large_text')
              .map((e) => ({
                value: e.fieldName,
                label: e.fieldTitle.en,
              }));
          }
        } else if (eventActionName === 'queryFromTypesense') {
          options = selectedCollectionFields
            .filter((e) => e.type === 'text' || e.type === 'large_text')
            .map((e) => ({
              value: e.fieldName,
              label: e.fieldTitle.en,
            }));
        } else if (
          [
            'metropolCreditReportReferenceField',
            'iprsReferenceField',
            'kraReferenceField',
            'eStatementReferenceField',
            'mPesaReferenceField',
          ].includes(args.name)
        ) {
          options = selectedCollectionFields
            .filter((e) => BelongsCreatedByRefField.includes(e.type))
            .map((e) => ({
              value: e.fieldName,
              label: e.fieldTitle.en,
            }));
        } else {
          options = [
            ...selectedCollectionFields.map((e) => ({
              value: e.fieldName,
              label: e.fieldTitle.en,
            })),
            ...referenceFields,
          ];
        }
        break;
      }
      case DS_ZAPS:
        options = this.fetchZaps();
        break;
      case MULTI_TENANT_API:
        options = this.state.tenants.map((tenant, key) => ({
          value: tenant.uuid,
          label: tenant.name ? tenant.name : tenant.uuid,
        }));
        break;
      case SOURCE_API:
        options = this.getSourceOptions(eventAction);
        break;
      case SOURCE_PAGE_API:
      case SHOW_COMPONENT_PAGE_API:
      case HIDE_COMPONENT_PAGE_API:
      case REFRESH_PAGE_API:
        options = this.sourcePageOptions(values);
        break;
      case DS_CHAT_GPT:
        options = this.fetchExternalApiList(CHAT_GPT);
        break;
      case DS_SUPABASE:
        options = this.fetchExternalApiList(SUPABASE);
        break;
      case DS_DIRECTUS:
        options = this.fetchExternalApiList(DIRECTUS);
        break;
      case DS_APPWRITE:
        options = this.fetchExternalApiList(APP_WRITE);
        break;
      case DS_XANO:
        options = this.fetchExternalApiList(XANO);
        break;
      case DS_API_COLLECTION_FIELDS:
        options = this.apiCollectionFieldsOptions(values);
        break;
      case TOOLTIP_API:
        options = this.fetchToolTipTemplateList();
        break;
      case TOOLTIP_POSITION:
        options = toolTipPositionOptions;
        break;
      case TOOLTIPS_THEME:
        options = toolTipsThemeOptions;
        break;
      case TOOLTIPS_ANIMATION:
        options = toolTipsAnimationOptions;
        break;
      case TOOLTIPS_FOLLOW_CURSOR:
        options = toolTipsFollowCursorOptions;
        break;
      case AGREEMENT_TEMPLATE_API:
        options = this.props.template.mailTemplates
          .filter((item) => !item.parentTemplateId)
          .sort(dynamicSort('name'))
          .map((item, key) => ({ value: item.uuid, label: item.name }));
        break;
      case AGREEMENT_TEMPLATE_PDF_API:
        options = this.props.template.agreementTemplates
          .sort(dynamicSort('name'))
          .map((item, key) => ({ value: item.uuid, label: item.name }));
        break;
      case TYPESENSE_SEARCH_COLLECTION_API:
        options = collections
          .filter((e) => e.typesenseMapping.length)
          .map((e) => ({
            value: e.uuid,
            label: e.collectionTitle,
          }));
        break;
      case EMAIL_SERVICE_PLUGIN_API:
        options = [{ value: '', label: 'DrapCode Default Email Provider' }];
        if (installedPluginCodes.includes(pluginCode.AWS_SES)) {
          options.push({ value: 'AWS_SES', label: 'AWS SES' });
        }
        if (installedPluginCodes.includes(pluginCode.SENDGRID)) {
          options.push({ value: 'SENDGRID', label: 'SendGrid' });
        }
        if (installedPluginCodes.includes(pluginCode.RESEND)) {
          options.push({ value: 'RESEND', label: 'Resend' });
        }
        break;
      case COLLECTION_META_DATA_MAPPING_API:
        const metaDataCollectionName = values['metaDataCollection'];
        const targetDataCollectionName = values['targetDataCollection'];
        const selectedCollection = collections.find(
          (e) => e.collectionName === metaDataCollectionName,
        );
        const targetCollection = collections.find(
          (e) => e.collectionName === targetDataCollectionName,
        );
        let targetUuid = '';
        if (targetCollection) {
          targetUuid = targetCollection.uuid;
        }
        const selectedCollectionMappings = selectedCollection
          ? selectedCollection.metaDataTableMapping
          : [];
        const filteredCollectionMappings = selectedCollectionMappings.filter(
          (mapping) => mapping.targetCollection === targetUuid,
        );
        options = filteredCollectionMappings
          .sort(dynamicSort('name'))
          .map((item) => ({ value: item.uuid, label: item.mappingName }));
        break;
      case GET_ITEM_ID_FROM_API:
        options = getItemIdFromOptions;
        break;
      case 'signerIdentifierFieldApi':
        const signzySignersCollection = collections.find(
          (e) => e.collectionName === 'digital_document_signing_signers',
        );
        const selectedCollectionFields = signzySignersCollection
          ? signzySignersCollection.fields
          : [];
        options = selectedCollectionFields.map((e) => ({
          value: e.fieldName,
          label: e.fieldTitle.en,
        }));
        break;
      case 'conferenceProviderApi':
        if (installedPluginCodes.includes(pluginCode.GOOGLE_MEET)) {
          options.push({ value: 'GOOGLE_MEET', label: 'Google Meet' });
        }
        if (installedPluginCodes.includes(pluginCode.ZOOM)) {
          options.push({ value: 'ZOOM', label: 'Zoom' });
        }
        break;
      case 'googleCalendarCollectionApi':
        options = collections
          .filter((e) => e.googleCalendarMapping.length)
          .map((e) => ({
            value: e.collectionName,
            label: e.collectionTitle,
          }));
        break;
      case 'accountHolderFieldApi':
        const accountHolderCollection = collections.find(
          (e) => e.collectionName === 'account_aggregator_account_holders',
        );
        const accountHolderFields = accountHolderCollection ? accountHolderCollection.fields : [];
        options = accountHolderFields.map((e) => ({
          value: e.fieldName,
          label: e.fieldTitle.en,
        }));
        break;
      case 'fiTransactionsFieldApi':
        const fiTransactionCollection = collections.find(
          (e) => e.collectionName === 'account_aggregator_fi_transactions',
        );
        const fiTransactionsFields = fiTransactionCollection ? fiTransactionCollection.fields : [];
        options = fiTransactionsFields
          .filter((e) => BelongsCreatedByRefField.includes(e.type))
          .map((e) => ({
            value: e.fieldName,
            label: e.fieldTitle.en,
          }));
        break;
      case 'contractsFieldApi':
        const contractsCollection = collections.find(
          (e) => e.collectionName === 'digital_document_signing_contracts',
        );
        const contractsFields = contractsCollection ? contractsCollection.fields : [];
        options = contractsFields
          .filter((e) => BelongsCreatedByRefField.includes(e.type))
          .map((e) => ({
            value: e.fieldName,
            label: e.fieldTitle.en,
          }));
        break;
      case SMS_SERVICE_PLUGIN_API:
        const providerMap = [
          { code: pluginCode.AWS_SNS, value: 'AWS_SNS', label: 'AWS SNS' },
          { code: pluginCode.TWILIO, value: 'TWILIO', label: 'Twilio' },
          { code: pluginCode.PARKEN, value: 'PARKEN', label: 'Parken' },
          {
            code: pluginCode.AFRICAS_TALKING_SMS,
            value: 'AFRICAS_TALKING_SMS',
            label: "Africa's Talking",
          },
          { code: pluginCode.HOSTPINNACLE, value: 'HOSTPINNACLE', label: 'HostPinnacle' },
        ];
        options = [
          { value: '', label: '- Select One -' },
          ...providerMap
            .filter(({ code }) => installedPluginCodes.includes(code))
            .map(({ value, label }) => ({ value, label })),
        ];
        break;
      case LOGOUT_ITEM_API:
        options = getItemIdForLogoutOptions;
        break;
    }
    return options;
  };

  fetchToolTipTemplateList = () => {
    let options = [];
    const { template } = this.props;
    const { tooltipTemplates } = template;
    options = tooltipTemplates.map((tooltip) => ({ label: tooltip.name, value: tooltip.uuid }));
    return options;
  };

  apiCollectionFieldsOptions = (values) => {
    const { externalapi, events } = this.props;
    const { collections } = events;
    let options = [];
    if (values) {
      const { chatGptId } = values;
      const { externalApis } = externalapi;
      const externalApi = externalApis.find((api) => api.uuid === chatGptId);
      if (externalApi) {
        const { collectionName } = externalApi;
        const collection = collections.find((coll) => coll.collectionName === collectionName);
        if (collection) {
          const { fields } = collection;
          fields.forEach((field) => {
            options.push({ label: field.fieldTitle.en, value: field.fieldName });
          });
        }
      }
    }
    return options;
  };

  sourcePageOptions = (values) => {
    const { events } = this.props;
    let options = [];
    switch (values.source) {
      case SNIPPET_TYPES.MODAL:
        options = this.getModalListFromSnippets(SNIPPET_TYPES.MODAL);
        break;
      case SNIPPET_TYPES.FLOATING_MODAL:
        options = this.getModalListFromSnippets(SNIPPET_TYPES.FLOATING_MODAL);
        break;
      case SNIPPET_TYPES.SUB_PAGE:
        options = this.getSubPageListFromSnippets();
        break;
      default:
        options = events.pages.map((item) => ({
          value: item.uuid,
          label: item.name,
        }));
        break;
    }
    return options;
  };

  constructorOptions = (collectionName) => {
    let options = [];
    let collections = this.props.events.collections;
    const selectedCollection = collections.find(
      (collection) => collection.collectionName === collectionName,
    );
    let constructors = selectedCollection ? selectedCollection.constructors : [];
    if (constructors.length > 0) {
      options = options.concat(
        constructors.map((constructor) => {
          return { value: constructor.uuid, label: constructor.customConstructorName };
        }),
      );
    }
    return options;
  };

  fetchZaps = () => {
    let options = [];
    const { externalApis } = this.props.externalapi;
    externalApis.forEach((wb) => {
      if (wb.externalApiType === ZAPIER && wb.setting.enabled)
        options.push({ value: wb.uuid, label: wb.externalApiName });
    });
    return options;
  };

  getComponentsElement = () => {
    let options = [];
    let pageElement = this.state.pageContent ? this.state.pageContent : {};
    const pageComponents =
      Object.keys(pageElement).length > 0 ? JSON.parse(pageElement['nocode-components']) : [];
    if (pageComponents) {
      options = getPageComponentElement(pageComponents, this.state.pageComponent);
    }
    return options;
  };

  getRefreshComponentsElement = (values) => {
    let options = [];
    let pageElement = this.state.refreshPageContent ? this.state.refreshPageContent : {};
    const pageComponents =
      Object.keys(pageElement).length > 0 ? JSON.parse(pageElement['nocode-components']) : [];
    if (pageComponents) {
      options = pageRefreshElementOptions(this.state);
    }
    return options;
  };

  getShowHidePageComponents = (values) => {
    let pageId = this.state.showHideComponentPageId;
    let pageContent = this.state.showHideComponentPageContent;
    let options = [];
    let pageElement = pageContent ? pageContent : {};

    const pageComponents =
      Object.keys(pageElement).length > 0 ? JSON.parse(pageElement['nocode-components']) : [];
    if (pageComponents) {
      options = pageShowHideComponentOptions(this.state);
    }
    return options;
  };

  getPageFormComponents = (values) => {
    let pageId = this.state.showHideComponentPageId;
    let pageContent = this.state.showHideComponentPageContent;
    let options = [];
    let pageElement = pageContent ? pageContent : {};

    const pageComponents =
      Object.keys(pageElement).length > 0 ? JSON.parse(pageElement['nocode-components']) : [];
    if (pageComponents) {
      options = getPageComponentOptions(this.state, ['form']);
    }
    return options;
  };

  getModalListFromSnippets = (modalType = SNIPPET_TYPES.MODAL) => {
    const { snippets } = this.props.events;
    let options = getSnippetModalOptions(snippets, modalType);
    return options;
  };

  getSubPageListFromSnippets = () => {
    let options = [];
    const { snippets } = this.props.events;
    const subPageSnippet = snippets.filter((snippet) => snippet.snippetType === 'SUB_PAGE');
    subPageSnippet.forEach((snippet) => {
      options.push({
        value: snippet.uuid,
        label: snippet.name,
      });
    });

    return options;
  };

  getPdfTemplateListFromSnippets = () => {
    let options = [];
    const { snippets } = this.props.events;
    const subPageSnippet = snippets.filter((snippet) => snippet.snippetType === 'PDF_TEMPLATE');
    subPageSnippet.forEach((snippet) => {
      options.push({
        value: snippet.uuid,
        label: snippet.name,
      });
    });

    return options;
  };

  fetchExternalApiList = (externalApiType) => {
    let options = [];
    const { externalApis } = this.props.externalapi;
    if (externalApis.length > 0) {
      if (externalApiType) {
        options = options.concat(
          externalApis
            .filter((externalApi) => externalApi.externalApiType === externalApiType)
            .map((externalAPI) => {
              return { value: externalAPI.uuid, label: externalAPI.externalApiName };
            }),
        );
      } else {
        options = options.concat(
          externalApis.map((externalAPI) => {
            return { value: externalAPI.uuid, label: externalAPI.externalApiName };
          }),
        );
      }
    }
    return options;
  };

  fetchCollectionList = () => {
    let options = [];
    const { collections, inMemoryCollections } = this.props.events;
    options = [...collections, ...inMemoryCollections].map((collection) => {
      return { value: collection.collectionName, label: collection.collectionTitle };
    });
    return options;
  };

  onChangeHandle = (args, values) => {
    if (refreshShowHideOpts.includes(args.name) && refreshShowHideOpts.includes(args.optionsType)) {
      this.handlePageComponentSelect(args, values);
    } else if (
      dropdownSourceOpts.includes(args.name) &&
      dropdownSourceOpts.includes(args.optionsType)
    ) {
      const { source } = values;
      if (!source || source === 'PAGE') {
        this.handlePageComponentSelect(args, values);
      } else this.loadSnippetComponents(args, values, source);
    }
  };

  onClickHandle = (args, values) => {
    // TODO:Can be removed after refactoring
    if (
      [
        'sendCurrentObjectID',
        'sendPreviousStepParentCollectionId',
        'sendCurrentUserId',
        'sendCurrentPageItemId',
        'isNewTab',
      ].includes(args.name)
    ) {
      if (args.name === 'sendCurrentObjectID') {
        values[args.name] = true;
        values['sendPreviousStepParentCollectionId'] = false;
        values['sendCurrentUserId'] = false;
        values['sendCurrentPageItemId'] = false;
      } else if (args.name === 'sendPreviousStepParentCollectionId') {
        values[args.name] = true;
        values['sendCurrentObjectID'] = false;
        values['sendCurrentUserId'] = false;
        values['sendCurrentPageItemId'] = false;
      } else if (args.name === 'sendCurrentUserId') {
        values[args.name] = true;
        values['sendCurrentObjectID'] = false;
        values['sendPreviousStepParentCollectionId'] = false;
        values['sendCurrentPageItemId'] = false;
      } else if (args.name === 'sendCurrentPageItemId') {
        values[args.name] = true;
        values['sendCurrentUserId'] = false;
        values['sendCurrentObjectID'] = false;
        values['sendPreviousStepParentCollectionId'] = false;
      }
    }
  };

  showDirectLinkText = (args) => {
    if (args.type === 'boolean') {
      return '';
    } else {
      let directLinkText = getDirectionLinkText(args);
      if (directLinkText) {
        return (
          <></>
          // <a
          //   onClick={() => this.closeAllOpenPopup(args)}
          //   className="direction-custom-link btn btn-outline-info"
          //   title={directLinkText}
          // >
          //   <i className="webconnect webconnect-box-arrow-up-right"></i>&nbsp;{directLinkText}
          // </a>
        );
      }
    }
  };

  getSelectPlaceholder = (args, values) => {
    if (dropdownSourceOpts.includes(args.name)) {
      const { source } = values;
      return source ? snakeCaseToTitleCase(source) : 'Page';
    } else return args.label;
  };

  onArgsValueChange = (name, value, args, values) => {
    let valuesObj = values;
    if (name && value) {
      valuesObj = { ...valuesObj, [name]: value };
      this.handleChange(name, value);
    }
    this.onChangeHandle(args, valuesObj);
  };

  createArgsField = (args, setFieldValue, setFieldTouched, values, action) => {
    if (
      ['browserStorageLocation', 'browserStorageItemIdPath'].includes(args.name) &&
      values['getItemIdFrom'] !== 'sendBSLItemId'
    )
      return '';
    if (
      ['browserStorageLocationRequest', 'browserStorageItemIdPathRequest'].includes(args.name) &&
      values['getRequestIdFrom'] !== 'sendBSLItemId'
    )
      return '';
    if (['dltTemplateId', 'smsType'].includes(args.name) && values['smsServicePlugin'] !== 'PARKEN')
      return '';
    if (['bankField'].includes(args.name) && values['statementType'] !== 'BANK') return '';
    if (browserStorageAndConsoleArgs.includes(args.name)) return '';
    if (
      [
        'firstPartyName',
        'secondPartyNameField',
        'stampDutyPaidBy',
        'considerationPriceField',
        'stateCode',
        'articleCode',
        'stampDutyValue',
        'purposeOfStampDuty',
        'mergeLimit',
        'location',
        'lossCap',
        'dynamicStampConsumption',
      ].includes(args.name) &&
      !values['addEStampPayload']
    )
      return '';
    if (args.name === 'boldSignPhoneNumberField' && ['Email', ''].includes(values['deliveryMode']))
      return '';
    if (args.name === 'boldSignEmailField' && ['SMS'].includes(values['deliveryMode'])) return '';
    if (args.type === 'dropdown') {
      let formatOptions = args.options
        ? args.options.map((option) => {
            if (option.value) {
              return { value: option.value, label: option.label };
            } else {
              return { value: option, label: option };
            }
          })
        : [];
      const options = this.getSelectOption(args, values);
      return (
        <div className="form-group" key={args.name}>
          {this.showDirectLinkText(args)}
          <CustomInputWithIconNoFormGroup
            title={args.label}
            icon="select"
            required={args.optional ? false : true}
          >
            <CustomSelect
              name={args.name}
              isMulti={args.multi || false}
              onChange={setFieldValue}
              onBlur={setFieldTouched}
              onChangeValue={(name, value) => this.onArgsValueChange(name, value, args, values)}
              options={formatOptions.length > 0 ? formatOptions : options}
              value={values[args.name] || args.value}
              placeholder={this.getSelectPlaceholder(args, values)}
            />
            <ErrorMessage name={args.name}>
              {(msg) => <p className="text-error">{msg}</p>}
            </ErrorMessage>
            {!!getFieldDescriptionText(args, action) && (
              <TooltipInfo
                title={getFieldDescriptionText(args, action)}
                headerText={`What's ${args.label}?`}
                showHeader={true}
                showArrow={true}
                append={true}
              />
            )}
          </CustomInputWithIconNoFormGroup>
          <small className="input-group" style={{ paddingLeft: '12%' }}>
            {getFieldDescriptionText(args, action)}
          </small>
        </div>
      );
    } else if (args.type === 'textArea') {
      return (
        <div className="form-group" key={args.name}>
          {this.showDirectLinkText(args)}
          <CustomInputWithIconNoFormGroup
            title={args.label}
            icon="textarea"
            required={args.optional ? false : true}
          >
            <Field
              type="text"
              as="textarea"
              rows={5}
              col={10}
              name={args.name}
              className="form-control form-control-sm"
              autoComplete="off"
              placeholder={args.label}
            />
            <ErrorMessage name={args.name}>
              {(msg) => <p className="texterror">{msg}</p>}
            </ErrorMessage>
          </CustomInputWithIconNoFormGroup>
        </div>
      );
    } else if (args.type === 'boolean' && !!!args['asRadio']) {
      return (
        <div className="form-group" key={args.name}>
          <div className="input-group">
            <div className="input-group-prepend" title={args.label}>
              <span className="input-group-text">
                <i className={`wb ${iconForField(args.type + '-toggle')}`}></i>
              </span>
            </div>
            <div className="form-check">
              <label className="form-check-label">
                <Field
                  type="checkbox"
                  name={args.name}
                  className="form-check-input"
                  title={args.name}
                />
                {args.label}
                <span className="form-check-sign">
                  <span className="check"></span>
                </span>
              </label>
              <ErrorMessage name={args.name}>
                {(msg) => <p className="text-error">{msg}</p>}
              </ErrorMessage>
            </div>
            {getFieldDescriptionInfoByName(args, action)}
          </div>
          {[
            'enableResetForm',
            'enableSubmitForm',
            'clearAllResponseData',
            'clearAllFormData',
            'isNonPersistent',
          ].includes(args.name) ? (
            <small className="input-group" style={{ paddingLeft: '12%' }}>
              {getFieldDescriptionTextByName(args, action)}
            </small>
          ) : (
            ''
          )}
        </div>
      );
    } else if (args.type === 'boolean' && !!args['asRadio']) {
      // TODO:Can be removed after refactoring
      return (
        <div className="form-group" key={args.name}>
          <div className="input-group">
            <div className="input-group-prepend" title={args.label}>
              <span className="input-group-text">
                <i className={`wb ${iconForField(args.type + '-toggle')}`}></i>
              </span>
            </div>
            <div className="form-check">
              <label className="form-check-label">
                <Field
                  type="checkbox"
                  name={args.name}
                  className="form-check-input"
                  title={args.name}
                  onClick={() => this.onClickHandle(args, values)}
                />
                {args.label}
                <span className="form-check-sign">
                  <span className="check"></span>
                </span>
              </label>
            </div>
            {getFieldDescriptionInfoByName(args, action)}
          </div>
        </div>
      );
    } else if (args.type === 'text') {
      return (
        <div className="form-group" key={args.name}>
          {this.showDirectLinkText(args)}
          <CustomInputWithIconNoFormGroup
            title={args.label}
            icon="text"
            required={args.optional ? false : true}
          >
            <Field
              type="text"
              name={args.name}
              className="form-control form-control-sm"
              autoComplete="off"
              placeholder={args.placeholder ? args.placeholder : args.label}
            />
            <ErrorMessage name={args.name}>
              {(msg) => <p className="text-error">{msg}</p>}
            </ErrorMessage>
            {!!getFieldDescriptionTextByName(args, action) && (
              <TooltipInfo
                title={getFieldDescriptionTextByName(args, action)}
                headerText={`What's this?`}
                showHeader={true}
                showArrow={true}
                append={true}
              />
            )}
          </CustomInputWithIconNoFormGroup>
          {[
            'confirmationMessage',
            'confirmBtnText',
            'cancelBtnText',
            'clearResponseSelectedKeys',
            'clearFormSelectedKeys',
          ].includes(args.name) && (
            <small className="input-group" style={{ paddingLeft: '12%' }}>
              {getFieldDescriptionTextByName(args, action)}
            </small>
          )}
        </div>
      );
    } else if (args.type === 'number') {
      return (
        <div className="form-group" key={args.name}>
          {this.showDirectLinkText(args)}
          <CustomInputWithIconNoFormGroup
            title={args.label}
            icon="number"
            required={args.optional ? false : true}
          >
            <Field
              type={'number'}
              name={args.name}
              min={args.min}
              max={args.max}
              className="form-control form-control-sm"
              autoComplete="off"
              placeholder={args.label}
            />
            <ErrorMessage name={args.name}>
              {(msg) => <p className="text-error">{msg}</p>}
            </ErrorMessage>
            {!!getFieldDescriptionTextByName(args, action) && (
              <TooltipInfo
                title={getFieldDescriptionTextByName(args, action)}
                headerText={`What's this?`}
                showHeader={true}
                showArrow={true}
                append={true}
              />
            )}
          </CustomInputWithIconNoFormGroup>
          {['overrideResetWaitTime', 'overrideSubmitWaitTime'].includes(args.name) ? (
            <small className="input-group" style={{ paddingLeft: '12%' }}>
              {getFieldDescriptionTextByName(args, action)}
            </small>
          ) : (
            ''
          )}
        </div>
      );
    } else if (args.type === 'browserStorageLocation') {
      return (
        <BrowserStorageLocationField
          fieldName={args.name}
          values={values}
          setFieldValue={setFieldValue}
          setFieldTouched={setFieldTouched}
          description={`Choose the browser storage location to retrieve the item's UUID.`}
        />
      );
    }
  };

  renderParameters = (setFieldValue, setFieldTouched, values, action) => {
    const paramField = [];
    if (action) {
      action.args.forEach((args) => {
        paramField.push(this.createArgsField(args, setFieldValue, setFieldTouched, values, action));
      });
    }
    return paramField;
  };

  handleSubmit = (values) => {
    const {
      actionData: { args },
      eventAction,
      externalapi,
      actions,
      version,
      projectId,
      selectedEvent,
    } = this.props;
    let parameters = [];
    Object.keys(values).map((value) => {
      const action = args.find((param) => param.name === value);
      parameters.push({ name: value, value: values[value], type: action.type });
    });
    let actionFormData = eventAction;
    actionFormData.parameters = parameters;
    if (sendDataToApiOptions.includes(actionFormData.name)) {
      const { externalApis } = externalapi;
      const selectedExternalApi =
        externalApis && values.webhookId
          ? externalApis.find((e) => e.uuid === values.webhookId)
          : '';
      const bodyDataFrom = selectedExternalApi ? selectedExternalApi.bodyDataFrom : 'noDynamicData';
      const sendFormData = !!(selectedExternalApi && selectedExternalApi.sendFormData);
      parameters.push({ name: 'bodyDataFrom', value: bodyDataFrom, type: 'text' });
      parameters.push({
        name: 'sendFormData',
        value: sendFormData,
        type: 'boolean',
      });
    }
    actions.updateAction({
      projectId,
      version,
      eventId: selectedEvent.uuid,
      data: actionFormData,
    });
    this.props.hideModal();
  };

  loadPageComponents = (componentPageId, args) => {
    const { props, state } = this;
    const { projectId, events, version } = props;
    const { defaultPage } = events;
    const { refreshPageId, showHideComponentPageId } = state;
    if (
      defaultPage &&
      (componentPageId !== refreshPageId || componentPageId !== showHideComponentPageId)
    ) {
      const uri =
        defaultPage.uuid === componentPageId
          ? `pages/default-page/content`
          : `pages/${componentPageId}/content`;
      const header = builderSurfaceJsonContentHeader(projectId);
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}${version}/${uri}`,
        header,
      );
      doRequest.then(
        (res) => {
          this.setState({
            ...this.state,
            refreshPageContent: res.data,
            refreshPageId: componentPageId,
            showHideComponentPageContent: res.data,
            showHideComponentPageId: componentPageId,
            pageContent: res.data,
            pageId: componentPageId,
          });
        },
        (err) => {
          console.error('loadPageComponents errororo', err);
        },
      );
    }
  };

  loadSnippetComponents = (args, values, type) => {
    const { version } = this.props;
    const componentPageId =
      type === 'MODAL' ? values[args.name].split(CUSTOM_MODAL_SEPARATOR)[1] : values[args.name];
    if (componentPageId) {
      const { projectId } = this.props;
      const uri = `projects/${projectId}/snippet-templates/${componentPageId}`;
      const header = builderSurfaceJsonContentHeader(projectId);
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/${uri}`,
        header,
      );
      doRequest.then(
        (res) => {
          this.setState({
            ...this.state,
            pageContent: res.data['content'],
            showHideComponentPageContent: res.data['content'],
            refreshPageContent: res.data['content'],
          });
        },
        (err) => {
          console.error('loadSnippetComponents error', err);
        },
      );
    }
  };

  //TODO: Refactoring needed to manage states
  handlePageComponentSelect = (args, values) => {
    if (values[args.name]) {
      this.loadPageComponents(values[args.name], args);
    }
  };

  showAlertMessage = (actionData) => {
    const { alertMessage } = actionData;
    if (!alertMessage) return '';
    return (
      <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
        <div className="alert alertWarning">
          <div className="alert-icon">
            <i
              className="wb webconnect-exclamation-circle-fill"
              style={{ verticalAlign: '1px' }}
            ></i>
          </div>
          {alertMessage}
        </div>
      </div>
    );
  };

  bslOptionHandler = () => {
    this.setState({
      showBSLOption: !this.state.showBSLOption,
    });
  };

  clogOptionHandler = () => {
    this.setState({
      showCLOption: !this.state.showCLOption,
    });
  };

  validateFormDataSessionKey = (value) => {
    let error;
    if (!value) {
      error = "Form Data Session Key can't be blank";
    } else if (!/^[^_][A-Za-z_0-9]+$/i.test(value)) {
      error = 'Form Data Session Key should not contain special characters';
    } else if (value.length > 50) {
      error = 'Form Data Session Key can not be more than 50 characters';
    }
    return error;
  };

  validateResponseDataSessionKey = (value) => {
    let error;
    if (!value) {
      error = "Response Data Session Key can't be blank";
    } else if (!/^[^_][A-Za-z_0-9]+$/i.test(value)) {
      error = 'Response Data Session Key should not contain special characters';
    } else if (value.length > 50) {
      error = 'Response Data Session Key can not be more than 50 characters';
    }
    return error;
  };

  showBrowserStorageAndConsoleOptions = (eventAction, values, setFieldValue, setFieldTouched) => {
    const { showBSLOption, showCLOption } = this.state;
    if (
      [
        'initiateMPesaC2BPayment',
        'initiateMPesaB2CPayout',
        'metropolCreditReport',
        'iprsKenya',
        'kraPinChecker',
        'eStatementAnalysis',
      ].includes(eventAction.name)
    ) {
      return (
        <>
          <div className="form-group">
            <button
              onClick={this.bslOptionHandler}
              className="btn btn-icon-only btn-outline-info ml-5 p-1"
              title="Show Browser Storage Options"
              type="button"
            >
              <i className="wb webconnect-cog"></i>&nbsp;Browser Storage Options
            </button>

            <button
              onClick={this.clogOptionHandler}
              className="btn btn-icon-only btn-outline-info ml-2 p-1"
              title="Show Console Log Options"
              type="button"
            >
              <i className="wb webconnect-cog"></i>&nbsp;Console Log Options
            </button>
          </div>

          {showBSLOption && (
            <BrowserStorageOptions
              values={values}
              setFieldValue={setFieldValue}
              setFieldTouched={setFieldTouched}
              validateFormDataSessionKey={this.validateFormDataSessionKey}
              validateResponseDataSessionKey={this.validateResponseDataSessionKey}
            />
          )}
          {showCLOption && <ConsoleLogOptions values={values} />}
        </>
      );
    } else {
      return '';
    }
  };

  render() {
    const { eventAction, actionData } = this.props;
    return (
      <Fragment>
        <Formik
          enableReinitialize={true}
          initialValues={createActionSettingsSchema(actionData, eventAction)}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            this.handleSubmit(values);
            setSubmitting(false);
            resetForm();
          }}
        >
          {({ isSubmitting, values, setFieldValue, setFieldTouched, errors }) => (
            <Form>
              <div className="row">
                <div className="col-12">
                  {this.renderParameters(setFieldValue, setFieldTouched, values, actionData)}
                </div>
              </div>
              {this.showAlertMessage(actionData)}
              {this.showBrowserStorageAndConsoleOptions(
                eventAction,
                values,
                setFieldValue,
                setFieldTouched,
              )}
              <div className="row">
                <div className="col-md-6 text-left">
                  <button
                    type="button"
                    className="btn btn-outline-secondary btn-sm"
                    onClick={this.props.hideModal}
                  >
                    <span>
                      <i className="wb webconnect-times"></i> Cancel
                    </span>
                  </button>
                </div>
                <div className="col-md-6 text-right">
                  <button
                    type="submit"
                    disabled={validateSubmitBtn(values, eventAction)}
                    className={`btn btn-sm ${
                      validateSubmitBtn(values, eventAction) ? 'btn-default' : 'btn-theme-submit'
                    }`}
                  >
                    <i className="wb webconnect-save-regular"></i>&nbsp;Save&nbsp;
                    <CustomLoader loading={this.props.showLoaderForAction} />
                  </button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    event: state.event,
    template: state.template,
    dataConnector: state.dataConnector,
    externalapi: state.externalapi,
    appSetting: state.appSetting,
    customComponent: state.customComponent,
    template: state.template,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
    templateActions: bindActionCreators({ ...templateActions }, dispatch),
    externalApiActions: bindActionCreators({ ...externalApiActions }, dispatch),
    appSettingActions: bindActionCreators({ ...appSettingActions }, dispatch),
    customComponentsActions: bindActionCreators({ ...customComponentsActions }, dispatch),
    toolTipActions: bindActionCreators({ ...toolTipActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ActionForm);
